import { Container } from './index.styles';

export interface BackdropProps extends Component {
  /**
   * Triggered when background is clicked. Required.
   */
  handleClick: () => void;
  /**
   * useBackground if no background backdrop is transparent. Optional.
   */
  useBackground?: boolean;
  /**
   * Speed of background animation.
   */
  animationSpeed?: number;
}

/**
 * Heading
 */
export const Backdrop = (props: BackdropProps) => {
  const { handleClick, animationSpeed = 0.3, useBackground = true } = props;

  return (
    <Container
      data-testid="backdrop-component"
      onClick={() => handleClick()}
      $useBackground={useBackground}
      transition={{ duration: animationSpeed * 1.66, ease: 'easeInOut' }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      key="ds-backdrop"
    />
  );
};
